import styled from 'styled-components';
import colors from 'constants/colors';
import { SubHeaderContainer } from 'screens/Reports/DailyReconciliationReport/style';

export const PriceSubHeaderContainer = styled(SubHeaderContainer)``;

export const PriceTableContainer = styled.table`
  width: 100%;
  height: 200px;
  color: ${colors.white};
  font-size: 14px;

  th {
    border-top: 1px solid ${colors.charcoal};
    border-right: 1px solid ${colors.charcoal};
    border-bottom: 1px solid ${colors.white};
    padding: 10px 10px;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 1px;
  }

  td {
    height: 44px;
    padding: 5px 10px;
  }

  tbody {
    tr:nth-child(odd) {
      background-color: ${colors.black1}
    }
    tr:nth-child(even) {
      background-color: ${colors.black5}
    }
  }

  .titleColumn {
    width: 12%;
    border-right: 1px solid ${colors.white};
  }
  .dataColumn {
    width: 6%;
  }

  .title {
    text-align: right;
    font-weight: bold;
  }

  .titleBorder {
    border-right: 1px solid ${colors.white};
    border-bottom: 1px solid ${colors.charcoal};
  }

  .subTitle {
    font-weight: normal;
  }

  .commonColumn {
    border: 1px solid ${colors.charcoal};
  }

  .bottomRow {
    border-bottom: 1px solid ${colors.white};
  }

  .bottomColumn {
    border-right: 1px solid ${colors.charcoal};
  }

  .bottomBorder {
    border-right: 1px solid ${colors.white};
  }
`;
